module.exports = __webpack_public_path__ + "static/media/foto-friends-balls.f0c01de5.jpg";